<template>
  <div class="form-title">
    {{params.value}}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import filters from '../filters.js'
export default {
  name: 'v-text',
  props: ['params', 'rowData'],
  filters,
  computed: {
    ...mapGetters([
      'brands'
    ])
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
